import { PaymentMethod, PaymentType, PaymentTypes } from "shared/utils/payment";
import { PaymentMethod as MiddlewarePaymentMethod } from "shared/api/middleware-api-client";
import { usePanelPaymentMethods } from "./usePanelPaymentMethods";
import { useState } from "react";
import { PaymentActions } from "shared/utils/payment-methods";

const usePayment = () => {
  const paymentMethodsMutation = usePanelPaymentMethods();
  const [paymentAction, setPaymentAction] = useState<PaymentActions | null>(
    null,
  );

  const getPaymentTypeList = async (paymentTypes: PaymentTypes[]) => {
    const paymentTypesWithMethods: PaymentType[] = [];

    for (const paymentType of paymentTypes) {
      paymentTypesWithMethods.push({
        action: paymentType.action,
        methods: (await getPaymentMethodsForTypes(paymentType)) ?? [],
      });
    }

    return paymentTypesWithMethods;
  };

  const getPaymentMethodsForTypes = async (paymentType: PaymentTypes) => {
    try {
      const paymentMethods = await paymentMethodsMutation.mutateAsync();
      if (!paymentMethods) return [];

      const typePaymentMethods: PaymentMethod[] = [];
      for (const method of paymentType.methodIds) {
        const paymentMethod: MiddlewarePaymentMethod | undefined =
          paymentMethods.find((m: MiddlewarePaymentMethod) => m.id === method);

        if (paymentMethod) {
          typePaymentMethods.push({
            id: paymentMethod.id,
            name: paymentMethod.name,
            visibleName: paymentMethod.visibleName,
            maxAmount: parseFloat(paymentMethod.maxAmount),
            minAmount: parseFloat(paymentMethod.minAmount),
            countries: paymentMethod.countries,
            banks: paymentMethod.banks,
            brand: paymentMethod.brand,
          });
        }
      }

      return typePaymentMethods;
    } catch (error) {}
  };

  return { getPaymentTypeList, paymentAction, setPaymentAction };
};
export default usePayment;
